import { frontendURL } from '../../../helper/URLHelper';
import TasksIndex from './pages/TasksIndex.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tasks'),
    name: 'calendar_index',
    component: TasksIndex,
    meta: commonMeta,
  },
];
